import React from 'react';

function Param(props) {
  return (
    <span className="code-param">{props.children}</span>
  );
}

export default Param;